import request from "@/utils/request"

export default function agentGetSocketStateById(params) {
    return request({
        url: '/device/socket/agentGetSocketStateById',
        params
    })
}